import React from 'react'
import { FAIcon } from './FAIcon'

export class CatchError extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
      info: null
    }
  }

  // eslint-disable-next-line handle-callback-err
  static getDerivedStateFromError (error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch (error, info) {
    this.setState({
      hasError: true,
      error: error,
      info: info
    })
  }

  renderError () {
    const { error, info } = this.state
    const { withClassNames } = this.props

    let classNames = ['text-center']

    if (withClassNames) {
      classNames.push(withClassNames)
    }

    return <div className={classNames.join(' ')}>
      <h3>Error <FAIcon style={{ cursor: 'pointer' }} name='redo' onClick={() => { this.setState({ hasError: false, error: null, info: null }) }} /></h3>
      <p><b>Message</b></p>
      <p>{(error || {}).message}</p>
      <p><b>Stack Trace</b></p>
      <p>{(error || {}).stack}</p>
      <p><b>Component Trace</b></p>
      <p>{(info || {}).componentStack}</p>
    </div>
  }

  render () {
    const { children } = this.props
    const { hasError } = this.state

    if (hasError) {
      return this.renderError()
    }

    return children
  }
}
